import React from 'react'

import PengembanganKompetensiApp from 'app/KinerjaPage/pages/Pelaksanaan/PengembanganKompetensi'
import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { PageGuardPelaksanaanDate } from 'app/KinerjaPage/pages/PelaksanaanV2/components/PageGuardPelaksanaanDate'
import { useNewDocumentFlow } from 'app/KinerjaShared/hooks/useNewDocumentFlow'
import { NotFoundError } from 'utils/customError'
import { PengembanganKompetensiV2 } from 'app/KinerjaPage/pages/PelaksanaanV2/PengembanganKompetensiV2'
import { KinerjaTipeProvider } from 'app/KinerjaShared/components/KinerjaTipeProvider'

import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    _context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const isKinerjaEnabled = toggle?.['kinerja-enabled'] || false
    const isKinerjaPelaksanaanEnabled =
      toggle?.['kinerja-pelaksanaan-enabled'] || false

    if (!isKinerjaEnabled || !isKinerjaPelaksanaanEnabled) {
      return {
        redirect: {
          destination: '/404',
          permanent: false,
        },
      }
    }
  },
})

const PengembanganKompetensi = () => {
  const { status } = useNewDocumentFlow()

  if (status === 'DISABLED') {
    throw new NotFoundError('', 'Not Found')
  }

  if (status === 'NEW_DOCUMENT_FLOW') {
    return (
      <KinerjaTipeProvider tipe="SPF">
        <PageGuardPelaksanaanDate>
          <PengembanganKompetensiV2 />
        </PageGuardPelaksanaanDate>
      </KinerjaTipeProvider>
    )
  }

  return (
    <PageGuardPelaksanaanDate>
      <PengembanganKompetensiApp />
    </PageGuardPelaksanaanDate>
  )
}

PengembanganKompetensi.Layout = KinerjaLayout

PengembanganKompetensi.layoutOpts = {
  hasHeader: true,
}
export default PengembanganKompetensi
